/**
 * Learn more about deep linking with React Navigation
 * https://reactnavigation.org/docs/deep-linking
 * https://reactnavigation.org/docs/configuring-links
 */

import { LinkingOptions } from "@react-navigation/native";
import * as Linking from "expo-linking";

import { RootStackParamList } from "../types";

const linking: LinkingOptions<RootStackParamList> = {
  prefixes: [Linking.createURL("/")],
  config: {
    screens: {
      Root: {
        screens: {
          Home: {
            screens: {
              Reports: {
                screens: {
                  CustomerStatus: {
                    path: "reports/customerStatus",
                    screens: {
                      CustomerStatusReportsScreen: "CustomerStatus",
                    },
                  },
                  CustomerStatusDetailReportScreen: {
                    path: "reports/customerStatus/details",
                    screens: {
                      CustomerStatusDetailReportScreen:
                        "CustomerStatusDetailReportScreen",
                    },
                  },
                  Products: {
                    path: "reports/search/products",
                    screens: {
                      ProductsReportsScreen: "Products",
                    },
                  },
                  Stocks: {
                    path: "reports/stocks",
                    screens: {
                      StocksReportsScreen: "Stocks",
                    },
                  },
                  StockReportDetailsReportScreen: {
                    path: "reports/stock/view",
                    screens: {
                      StockReportDetailsReportScreen:
                        "StockReportDetailsReportScreen",
                    },
                  },
                  Operations: {
                    path: "reports/operations",
                    screens: {
                      OperationsScreen: "Operations",
                    },
                  },
                  ProductionStocks: {
                    path: "reports/production/stocks",
                    screens: {
                      ProductionStocksReportsScreen: "ProductionStocks",
                    },
                  },
                  ProductionStockDetailsReportScreen: {
                    path: "reports/production/stocks/view",
                    screens: {
                      ProductionStockDetailsReportScreen:
                        "ProductionStockDetailsReportScreen",
                    },
                  },
                  RawMaterialStocksOverView: {
                    path: "reports/production/raw",
                    screens: {
                      RawMaterialStocksOverviewReportsScreen:
                        "RawMaterialStocksOverView",
                    },
                  },
                  RawMaterialStocksDetails: {
                    path: "reports/production/rawDetail",
                    screens: {
                      RawMaterialStocksReportsScreen:
                        "RawMaterialStocksDetails",
                    },
                  },
                  WarehouseInventory: {
                    path: "reports/warehouse/stocks",
                    screens: {
                      PmxInventoryReportsScreen: "WarehouseInventory",
                    },
                  },
                  PmxInventoryDetailsReportScreen: {
                    path: "reports/warehouse/stocks/details",
                    screens: {
                      PmxInventoryDetailsReportScreen:
                        "PmxInventoryDetailsReportScreen",
                    },
                  },
                  WarehouseDetailsInventory: {
                    path: "reports/warehouse/batch",
                    screens: {
                      PmxDetailsInventoryReportsScreen:
                        "WarehouseDetailsInventory",
                    },
                  },
                  PmxDetailsInventoryDetailReportScreen: {
                    path: "reports/warehouse/batch/details",
                    screens: {
                      PmxDetailsInventoryDetailReportScreen:
                        "PmxDetailsInventoryDetailReportScreen",
                    },
                  },
                  DynamicWidth: {
                    path: "reports/dynamic-width",
                    screens: {
                      PmxInventoryReportsScreen: "DynamicWidth",
                    },
                  },
                  SalesScorecard: {
                    path: "reports/sales-scorecard",
                  },
                  UsageSalesScorecard: {
                    path: "reports/usage-sales-scorecard",
                  },
                  ValueSalesScorecard: {
                    path: "reports/value-sales-scorecard",
                  },
                  InvoiceDNDetail: {
                    path: "reports/invoice-dn-detail",
                  },
                },
              },
              Artworks: {
                screens: {
                  ArtworkManagement: {
                    path: "artworks/list",
                    screens: {
                      ListArtworksScreen: "ArtworkManagement",
                    },
                  },
                  NewArtwork: {
                    path: "artworks/add",
                    screens: {
                      NewArtworkScreen: "NewArtwork",
                    },
                  },
                },
              },
              Containers: {
                screens: {
                  ContainersManagement: {
                    path: "containers/list",
                    screens: {
                      ContainersManagementScreen: "ContainersManagement",
                    },
                  },
                  ManageContainers: {
                    path: "containers/manage",
                    screens: {
                      ManageContainersScreen: "ManageContainers",
                    },
                  },
                  ItemsManagement: {
                    path: "containers/items/list",
                    screens: {
                      ItemsManagementScreen: "ItemsManagement",
                    },
                  },
                },
              },
              Operations: {
                screens: {
                  OperationsManagement: {
                    path: "operations/list",
                    screens: {
                      OperationsManagementScreen: "OperationsManagement",
                    },
                  },
                  ManageOperations: {
                    path: "operations/manage",
                    screens: {
                      ManageOperationsScreen: "ManageOperations",
                    },
                  },
                  PrepayOrder: {
                    path: "operations/new/prepay",
                    screens: {
                      PlaceOrderScreen: "PrepayOrder",
                    },
                  },
                  ReserveOrder: {
                    path: "operations/new/reserve",
                    screens: {
                      PlaceOrderScreen: "ReserveOrder",
                    },
                  },
                  PlaceOrder: {
                    path: "operations/new",
                    screens: {
                      PlaceOrderScreen: "PlaceOrder",
                    },
                  },
                  SingleOperation: {
                    path: "operation",
                    screens: {
                      SingleOperationScreen: "SingleOperation",
                    },
                  },
                },
              },
              Tracker: {
                screens: {
                  ProductTrackerReport: {
                    path: "tracker/item/tracker",
                    screens: {
                      ItemTrackerScreen: "ItemTracker",
                    },
                  },
                  ProductTrackerDetailsReport: {
                    path: "tracker/item/tracker/view",
                    screens: {
                      ProductTrackerDetailsReport:
                        "ProductTrackerDetailsReport",
                    },
                  },
                  TrackerDashboardReport: {
                    path: "tracker/item/tracker/dashboard",
                    screens: {
                      ItemTrackerDashboard: "ItemTrackerDashboard",
                    },
                  },
                  ChinaTrackerReport: {
                    path: "tracker/china/tracker",
                    screens: {
                      ChinaTrackerScreen: "ChinaTracker",
                    },
                  },
                  ChinaTrackerGanttReport: {
                    path: "tracker/china/tracker/planning",
                    screens: {
                      ChinaTrackerGanttScreen: "ChinaTrackerGantt",
                    },
                  },
                  ChinaTrackerDetailsReport: {
                    path: "tracker/china/tracker/view",
                    screens: {
                      ChinaTrackerDetailsReport: "ChinaTrackerDetailsReport",
                    },
                  },
                  ChinaShipmentReport: {
                    path: "tracker/china/shipment",
                    screens: {
                      ChinaShipmentScreen: "ChinaShipment",
                    },
                  },
                  ChinaShipmentDetailsReport: {
                    path: "tracker/china/shipment/view",
                    screens: {
                      ChinaShipmentDetailsReport: "ChinaShipmentDetailsReport",
                    },
                  },

                  GlobalShipmentReport: {
                    path: "tracker/global/shipment",
                    screens: {
                      ChinaGlobalShipment: "GlobalShipment",
                    },
                  },
                  GlobalShipmentDetailsReport: {
                    path: "tracker/global/shipment/view",
                    screens: {
                      GlobalShipmentDetailsReport:
                        "GlobalShipmentDetailsReport",
                    },
                  },
                },
              },
              Customer: {
                screens: {
                  KanbanPOCScreen: {
                    path: "sales/kanban/poc/screen",
                    screens: {
                      KanbanPOCScreen: "KanbanPOCScreen",
                    },
                  },
                  CustomerIssueReport: {
                    path: "sales/customer/issues",
                    screens: {
                      CustomerIssueScreen: "CustomerIssueScreen",
                    },
                  },
                  CustomerOrderReport: {
                    path: "sales/customer/orders",
                    screens: {
                      CustomerOrderScreen: "CustomerOrderScreen",
                    },
                  },
                  CustomerOrderSummaryReport: {
                    path: "sales/customer/orders/summary",
                    screens: {
                      CustomerOrderSummaryReport: "CustomerOrderSummaryReport",
                    },
                  },
                  CustomerIssueDetailsReport: {
                    path: "sales/customer/issues/summary",
                    screens: {
                      CustomerIssueDetailsReport: "CustomerIssueDetailsReport",
                    },
                  },
                  CustomerOrganizationsListScreen: {
                    path: "sales/customer/organizations",
                    screens: {
                      CustomerOrganizationsListScreen:
                        "CustomerOrganizationsListScreen",
                    },
                  },
                  OrganizationOrdersScreen: {
                    path: "sales/organizations/orders",
                    screens: {
                      OrganizationOrdersScreen: "OrganizationOrdersScreen",
                    },
                  },
                  OrganizationOrderSummaryScreen: {
                    path: "sales/organizations/orders/summary",
                    screens: {
                      OrganizationOrderSummaryScreen:
                        "OrganizationOrderSummaryScreen",
                    },
                  },
                },
              },
              Delivery: {
                screens: {
                  DeliveryReport: {
                    path: "delivery/list",
                    screens: {
                      DeliveryReportScreen: "DeliveryReport",
                    },
                  },
                  DeliveryAppointmentScreen: {
                    path: "delivery/appointments",
                    screens: {
                      DeliveryAppointmentScreen: "DeliveryAppointmentScreen",
                    },
                  },
                  ReserveStock: {
                    path: "delivery/reserve-stock",
                    screens: {
                      ReserveStockReportScreen: "ReserveStock",
                    },
                  },
                  StockTransferReport: {
                    path: "transfer/list",
                    screens: {
                      StockTransferReportScreen: "StockTransferReport",
                    },
                  },
                  DeliveryReportDetails: {
                    path: "delivery/list/details",
                    screens: {
                      DeliveryDetailsScreen: "DeliveryReportDetails",
                    },
                  },
                  SalesSampleRequestScreen: {
                    path: "delivery/sample-request",
                    screens: {
                      SalesSampleRequestScreen: "SalesSampleRequestScreen",
                    },
                  },
                  SampleRequestDetails: {
                    path: "delivery/sample-request/details",
                    screens: {
                      SampleRequestDetailsScreen: "SampleRequestDetails",
                    },
                  },
                },
              },
              Scans: {
                screens: {
                  ScanByOperator: {
                    path: "scan/operator",
                    screens: {
                      ScanByOperatorScreen: "ScanByOperator",
                    },
                  },
                },
              },
              OperationalScans: {
                screens: {
                  WorkOrderPlanning: {
                    path: "scan/work-orders-planning",
                    screens: {
                      WorkOrderPlanningScreen: "WorkOrderPlanning",
                    },
                  },
                  IntouchSchedule: {
                    path: "scan/intouch",
                    screens: {
                      IntouchScheduleReportScreen: "IntouchSchedule",
                    },
                  },
                  ScanDashboard: {
                    path: "scan/dashboard",
                    screens: {
                      ScanDashboardScreen: "ScanDashboard",
                    },
                  },
                  ScanByManager: {
                    path: "scan/manager",
                    screens: {
                      ScanByManagerScreen: "ScanByManager",
                    },
                  },
                },
              },
            },
          },
        },
      },
      AdminRoot: {
        screens: {
          AdminHome: {
            screens: {
              AdminDashboard: {
                path: "admin/home",
                screens: {
                  AdminDashboardScreen: "AdminDashboard",
                },
              },
              AdminOrganizations: {
                path: "admin/organizations",
                screens: {
                  AdminOrganizations: "AdminOrganizations",
                },
              },
              AdminOrganizationalUsers: {
                path: "admin/organizational-users",
                screens: {
                  AdminOrganizationalUsers: "AdminOrganizationalUsers",
                },
              },
              AdminOrganizationalUsersNavigate: {
                path: "admin/navigate-organizational-user",
                screens: {
                  AdminOrganizationalUsersNavigate:
                    "AdminOrganizationalUsersNavigate",
                },
              },
              UpdateAdminOrganizationUser: {
                path: "admin/update-organizational-user",
                screens: {
                  UpdateAdminOrganizationUser: "UpdateAdminOrganizationUser",
                },
              },
              AddAdminOrganizationUser: {
                path: "admin/add-organizational-user",
                screens: {
                  AddAdminOrganizationUser: "AddAdminOrganizationUser",
                },
              },
              AdminOrganizationalNavigate: {
                path: "admin/navigate-organizations",
                screens: {
                  AdminOrganizationalNavigate: "AdminOrganizationalNavigate",
                },
              },
              AddAdminOrganizations: {
                path: "admin/add-organizations",
                screens: {
                  AddAdminOrganizations: "AddAdminOrganizations",
                },
              },
              UpdateAdminOrganizations: {
                path: "admin/update-organizations",
                screens: {
                  UpdateAdminOrganizations: "UpdateAdminOrganizations",
                },
              },
            },
          },
          AdminHelp: {
            screens: {
              AdminSetting: {
                path: "admin/setting",
                screens: {
                  AdminSetting: "AdminSetting",
                },
              },
              AdminAccountProfileSetting: {
                path: "admin/account-settings",
                screens: {
                  AdminAccountProfileSetting: "AdminAccountProfileSetting",
                },
              },
            },
          },
        },
      },
      Modal: "modal",
      NotFound: "*",
      Login: "login",
      AdminLogin: "admin/login",
      ResetPassword: "reset-password/:token",
      UpdateArtwork: "artworks/update/:id",
      HubspotSettings: {
        screens: {
          Company: {
            screens: {
              CompanyScreen: "Company",
            },
          },
          Contact: {
            screens: {
              ContactScreen: "Contact",
            },
          },
          CreateCompany: {
            screens: {
              CreateCompanyScreen: "CreateCompany",
            },
          },
        },
      },
      SettingsM: "mobile/settings/",
      UserSettings: {
        screens: {
          Profile: {
            path: "user/setting/profile",
            screens: {
              ProfileScreen: "Profile",
            },
          },
          Notification: {
            path: "user/setting/notification",
            screens: {
              UserSettingNotificationScreen: "Notification",
            },
          },
        },
      },
      Invite: "invites/:id/",
      OrgSettings: {
        screens: {
          Company: {
            path: "org/settings/company",
            screens: {
              CompanyScreen: "Company",
            },
          },
          Branding: {
            path: "org/settings/branding",
            screens: {
              BrandingScreen: "Branding",
            },
          },
          Teams: {
            path: "org/settings/teams",
            screens: {
              TeamsScreen: "Teams",
            },
          },
          Active: {
            path: "/org/settings/teams/Active",
            screens: {
              TeamActiveMemberScreen: "Active",
            },
          },
          Users: {
            path: "/org/settings/user-list",
            screens: {
              TeamActiveMemberScreen: "Users",
            },
          },
        },
      },
      Help: "help",
      CreateUser: {
        path: "/org/settings/create",
        screens: {
          AddUserScreen: "Users",
        },
      },
      UpdateUser: {
        path: "/org/settings/update",
      },
      BypassUserDetails: {
        path: "/org/settings/user/view",
      },
    },
  },
};

export default linking;
